import { Navigate } from "react-router-dom";

/**
 * Protected route that requires specific permission(s)
 * @param {Object} props
 * @param {React.Component} props.children - The component to render if authorized
 * @param {string} props.permission - Single permission required
 * @param {string[]} props.anyPermissions - Array of permissions (user needs at least one)
 * @param {string[]} props.allPermissions - Array of permissions (user needs all)
 * @param {string[]} props.permissions - User's permissions array (passed from parent)
 * @param {boolean} props.user - Current user object
 * @param {boolean} props.loading - Loading state
 */
export default function ProtectedRouteWithPermission({
  children,
  permission,
  anyPermissions,
  allPermissions,
  permissions,
  user,
  loading,
  isUnauthorized,
}) {
  console.log('[ProtectedRouteWithPermission] 🔍 Component called with permissions prop:', permissions?.length || 0);

  console.log('[ProtectedRouteWithPermission] Check:', {
    loading,
    user: user?.email,
    requiredPermission: permission,
    requiredAnyPermissions: anyPermissions,
    requiredAllPermissions: allPermissions,
    userPermissions: permissions,
    permissionsCount: permissions?.length || 0
  });

  // Wait for auth to initialize
  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <div className="text-gray-600">Laden...</div>
      </div>
    );
  }

  // Not authenticated - check if unauthorized vs not logged in
  if (!user && isUnauthorized) {
    return <Navigate to="/unauthorized" />;
  }

  if (!user) {
    return <Navigate to="/login" />;
  }

  // Check permissions using the permissions array passed as prop
  let hasRequiredPermission = false;

  if (permission) {
    hasRequiredPermission = permissions?.includes(permission) || false;
    console.log('[ProtectedRouteWithPermission] Single permission check:', permission, '→', hasRequiredPermission);
  } else if (anyPermissions && anyPermissions.length > 0) {
    hasRequiredPermission = anyPermissions.some((code) => permissions?.includes(code)) || false;
    console.log('[ProtectedRouteWithPermission] Any permissions check:', anyPermissions, '→', hasRequiredPermission);
  } else if (allPermissions && allPermissions.length > 0) {
    hasRequiredPermission = allPermissions.every((code) => permissions?.includes(code)) || false;
    console.log('[ProtectedRouteWithPermission] All permissions check:', allPermissions, '→', hasRequiredPermission);
  } else {
    // No permission requirement specified - allow access
    hasRequiredPermission = true;
    console.log('[ProtectedRouteWithPermission] No permission required → allowing access');
  }

  // No permission - redirect to unauthorized
  if (!hasRequiredPermission) {
    console.log('[ProtectedRouteWithPermission] ❌ ACCESS DENIED - redirecting to /unauthorized');
    return <Navigate to="/unauthorized" />;
  }

  console.log('[ProtectedRouteWithPermission] ✅ ACCESS GRANTED - rendering children');

  // Authorized - render children
  return children;
}
